import BreadCrumbs from "components/widgets/bread-crumbs";
import SideNav, { ISideNavRoutes } from "./side-nav";
import TopNav from "./top-nav";
import { BiBookBookmark, BiCheckShield } from "react-icons/bi";
import { BsFolder } from "react-icons/bs";
import { MdOutlineTextsms } from "react-icons/md";
import { RiUserFollowLine } from "react-icons/ri";
import { FiServer } from "react-icons/fi";
import { AiOutlineWarning } from "react-icons/ai";

function DocsLayout({ children }: { children: JSX.Element }) {
  const routes: ISideNavRoutes[] = [
    {
      display: "Getting Started",
      path: "/docs",
      icon: <BiBookBookmark />,
      exact: true,
    },
    {
      display: "Authentication",
      path: "/docs/auth",
      icon: <RiUserFollowLine />,
      exact: true,
    },
    {
      display: "Single SMS",
      path: "/docs/single",
      icon: <MdOutlineTextsms />,
      exact: true,
    },

    {
      display: "Bulk SMS",
      path: "/docs/bulk",
      icon: <BsFolder />,
      exact: true,
    },
    {
      display: "Advance SMS",
      path: "/docs/advance",
      icon: <FiServer />,
      exact: true,
    },
    {
      display: "OTP Verify",
      path: "/docs/otp",
      icon: <BiCheckShield />,
      exact: true,
    },
    {
      display: "Error Handling",
      path: "/docs/error",
      icon: <AiOutlineWarning />,
      exact: true,
    },
  ];

  return (
    <>
      <TopNav />
      <div className="grid grid-cols-12 h-screen w-screen pt-16">
        <SideNav routes={routes} className="col-span-2 sm:col-span-1 md:col-span-3 lg:col-span-2 " />
        <main className="col-span-10 sm:col-span-11 md:col-span-9 lg:col-span-10 overflow-y-scroll">
          <BreadCrumbs />
          {children}
        </main>
        {/* <RightBar className="hidden xl:flex xl:col-span-2" /> */}
      </div>
    </>
  );
}

export default DocsLayout;
